export const UPDATE_NAVI = 'META_TYPE__UPDATE_NAVI'
export const PROVIDE_TITLE = 'META_TYPE__PROVIDE_TITLE'
